import { IGameState } from 'State/Game/IGameState';
import { hasPurchasedReactivationOffer } from 'State/Player/IAP/IAPStateHelper';
import DateHelper from 'Utility/DateHelper';
import { IPayerReactivationOfferData } from 'Utility/Helpers/IAP/IPayerReactivationOfferData';
import { PopupOffersOfType, PopupOfferType } from 'Utility/Helpers/IAP/PopupOffers';
import { ProductId } from 'Utility/Product';
import { Immutable } from 'Utility/Types';

export const PAYER_REACTIVATION_OFFERS: Record<
    keyof PopupOffersOfType<PopupOfferType.PAYER_REACTIVATION_OFFER>,
    IPayerReactivationOfferData
> = {
    [ProductId.PAYER_REACTIVATION_OFFER]: {
        timeSinceLastPurchase: DateHelper.Day * 14,
        cooldownTime: DateHelper.Hour * 72,
        offerTime: DateHelper.Hour * 12,
        condition: (state: Immutable<IGameState>) => {
            return !hasPurchasedReactivationOffer(state, ProductId.PAYER_REACTIVATION_OFFER);
        },
    },
    [ProductId.PAYER_REACTIVATION_OFFER_2]: {
        timeSinceLastPurchase: DateHelper.Day * 7,
        cooldownTime: DateHelper.Hour * 72,
        offerTime: DateHelper.Hour * 12,
        condition: (state: Immutable<IGameState>) => {
            return (
                !hasPurchasedReactivationOffer(state, ProductId.PAYER_REACTIVATION_OFFER_2) &&
                hasPurchasedReactivationOffer(state, ProductId.PAYER_REACTIVATION_OFFER)
            );
        },
    },
    [ProductId.PAYER_REACTIVATION_OFFER_3]: {
        timeSinceLastPurchase: DateHelper.Day * 7,
        cooldownTime: DateHelper.Hour * 72,
        offerTime: DateHelper.Hour * 12,
        condition: (state: Immutable<IGameState>) => {
            return (
                !hasPurchasedReactivationOffer(state, ProductId.PAYER_REACTIVATION_OFFER_3) &&
                hasPurchasedReactivationOffer(state, ProductId.PAYER_REACTIVATION_OFFER) &&
                hasPurchasedReactivationOffer(state, ProductId.PAYER_REACTIVATION_OFFER_2)
            );
        },
    },
};
